<template>
<PageShell>
  <article class="site-legal">
    <h1 class="site-h1">Terms &amp; Conditions</h1>
    <p>Welcome to <strong>GBAppWhats</strong>. By accessing or using this website, you agree to these Terms &amp; Conditions. If you do not agree with any part of these terms, please discontinue using the website.</p>

    <h2 class="site-h2">Website Content</h2>
    <p><router-link to="/">GBAppWhats.com</router-link> provides information, tutorials, reviews, and download resources related to GB WhatsApp. All content is published for informational and educational purposes only.</p>
    <p>While we make every effort to keep our content accurate and up to date, we cannot guarantee that all information will always be complete, accurate, or suitable for every device or Android version.</p>

    <h2 class="site-h2">User Responsibilities</h2>
    <p>By using this website, you agree to:</p>
    <ul class="site-ul">
      <li>Use the website only for lawful purposes.</li>
      <li>Verify information before relying on it.</li>
      <li>Download and install applications at your own discretion.</li>
      <li>Comply with all applicable laws and regulations in your country.</li>
    </ul>
    <p>Users are responsible for ensuring that any software they install is compatible with their device.</p>

    <h2 class="site-h2">Intellectual Property</h2>
    <p>Unless otherwise stated, all original content on GBAppWhats, including text, graphics, logos, and website design, is the property of GBAppWhats and may not be copied, republished, or redistributed without prior written permission.</p>
    <p>All third-party trademarks, product names, and logos remain the property of their respective owners.</p>

    <h2 class="site-h2">Third-Party Links</h2>
    <p>Our website may include links to third-party websites for additional information or downloads. These links are provided for convenience only.</p>
    <p>GBAppWhats does not control or endorse the content, privacy practices, or availability of external websites and is not responsible for any issues arising from their use.</p>

    <h2 class="site-h2">Limitation of Liability</h2>
    <p>GBAppWhats is provided on an "as is" basis without warranties of any kind.</p>
    <p>We are not responsible for:</p>
    <ul class="site-ul">
      <li>Installation failures</li>
      <li>Device compatibility issues</li>
      <li>Data loss</li>
      <li>Software errors</li>
      <li>Security problems caused by third-party applications</li>
    </ul>
    <p>Users should always back up important data before installing or updating any application.</p>

    <h2 class="site-h2">Changes to These Terms</h2>
    <p>We reserve the right to modify these Terms &amp; Conditions at any time. Updated versions will be published on this page with immediate effect.</p>

    <h2 class="site-h2">Contact Us</h2>
    <p>If you have questions regarding these Terms &amp; Conditions, please contact us at:</p>
    <p><a :href="'mailto:' + email"><strong>{{ email }}</strong></a></p>
  </article>
</PageShell>
</template>

<script>
import PageShell from '@/components/PageShell.vue'
import { SITE } from '@/constants/site'

export default {
  name: 'Terms',
  components: { PageShell },
  data() {
    return {
      email: SITE.email,
    }
  },
}
</script>
